"use client";
import {ModuleReadGuard} from "@/components/shared";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {VehicleTableConfig} from "@/data/vehicle/table.config";
import {getTableConfigWithAccess} from "@/libs/helper";
import type {NextPage} from "next";

export const Vehicles: NextPage = function () {
  // const data = VehicleTableConfig;
  const {roleAccess} = useNeoContext();
  const data = getTableConfigWithAccess(
    roleAccess,
    VehicleTableConfig,
    "MC003"
  );
  return (
    <ModuleReadGuard moduleCode="MC003">
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col px-5 py-5">
        {/* <div className="mb-4 flex-row px-3">
          <NeoHeader message="Vehicles"></NeoHeader>
        </div> */}
        <div className="flex-row">
          {/*<NeoTable table={data.table}></NeoTable>*/}
          <NeoAGgrid table={data.table}></NeoAGgrid>
        </div>
      </div>
    </ModuleReadGuard>
  );
};
